import EnhancedContentRecord from "models/view-models/enhanced-content-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// ---------------------------------------------------------------------------------------------
// #region Interfaces
// ---------------------------------------------------------------------------------------------

export interface SharedEnhancedContentBasePathParams {
    pageGuid: string;
}

/**
 * Search parameters when listing SharedEnhancedContent resources.
 * These get translated to QueryString parameters
 */
export interface SharedEnhancedContentListQueryParams {
    code: string;
    edition: string;
    externalIds?: string[];
    rootEntityId?: number;
    rootEntityType?: string;
    recipient?: string;
}

// #endregion Interfaces

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "public/pages/:pageGuid/sections/enhancedcontent";
const resourceType = EnhancedContentRecord;

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------

const SharedPageEnhancedContentService = {
    useBatchList: ServiceHookFactory.useNestedBatchedList<
        EnhancedContentRecord,
        SharedEnhancedContentBasePathParams,
        SharedEnhancedContentListQueryParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default SharedPageEnhancedContentService;

// #region Exports
